const locationFacilityTypes = {
  create: 'צור',
  update: 'עדכן',
  facilityType: {
    school: 'בית ספר',
    work: 'מקום עבודה',
  },
  toasts: {
    delete: {
      success: '[Location Facility] נמחק בהצלחה',
      errorMessage: 'משהו השתבש. נסה שוב מאוחר יותר.',
    },
    create: {
      success: '[Location Facility] נוצר בהצלחה',
      error: '[Location Facility] תגובת שרת שגויה',
    },
    update: {
      success: '[Location Facility] עודכן בהצלחה',
      error: '[Location Facility] תגובת שרת שגויה',
    },
  },
  deleteModal: {
    header: 'מחיקת מתקנים',
    body: 'האם אתה בטוח שברצונך למחוק {{num}} מתקנים?',
  },
  table: {
    headers: {
      name: 'שם',
      type: 'סוג',
      facilityTypes: 'סוג',
      contactName: 'שם איש קשר',
      email: 'אימייל',
      phone: 'מספר טלפון',
      address: 'כתובת',
      profile: 'פרופיל',
    },
    filters: {
      type: 'סוג',
    },
    actions: {
      delete: 'מחק',
    },
  },
  form: {
    tabs: {
      general: 'מידע מיקום',
      contact: 'מידע ליצירת קשר',
      hours: 'שעות',
      advancedSettings: 'העדפות',
      holidays: 'חגים',
    },
    forms: {
      general: {
        header: 'מיקום {{type}}',
        fields: {
          name: 'שם {{type}}',
          address: 'כתובת {{type}}',
          type: 'סוג מתקן',
          radius: {
            title: 'רדיוס התאמת כתובת',
            description:
              'הרדיוס במטרים או בפיט (m/ft למטרי/אימפריאלי) שבתוכו הזמנות מזוהות כמיקום ו/או כהמתן וחזור.',
          },
        },
      },
      contacts: {
        header: 'איש קשר: {{index}}',
        fields: {
          comment: 'הערה',
          address: 'כתובת',
          fax: 'פקס',
          phone: 'טלפון',
          email: 'אימייל',
          type: 'סוג',
          name: 'שם',
        },
        actions: {
          add: 'הוסף איש קשר +',
        },
      },
      shiftsHours: {
        header: {
          school: 'שעות בית ספר',
          work: 'שעות עבודה',
        },
        fields: {
          name: 'שם',
          status: 'סטטוס',
          start: 'התחלה',
          end: 'סיום',
          type: {
            title: 'סוג',
            options: {
              collect: 'איסוף',
              distribute: 'פיזור',
              both: 'שניהם',
            },
          },
          weekDays: 'ימי שבוע',
        },
        actions: {
          add: {
            default: '+ הוסף',
            school: '+ הוסף שעות בית ספר',
            work: '+ הוסף שעות עבודה',
          },
        },
      },
      reservationPreferences: {
        header: 'העדפות הזמנה',
        fields: {
          sharedWithOther: 'משותף עם אחרים',
          profile: 'פרופיל',
          suppliers: 'ספקים',
          service: 'שירות',
        },
      },
      advancedSettings: {
        header: 'הגדרות מתקדמות',
        fields: {
          consistentPassengerRouting: {
            title: 'מסלול נוסעים עקבי',
            toolTipInformation:
              'מבטיח שאותה קבוצת נוסעים תמיד תעקוב אחרי אותה הדרך אל המתקן וממנו, תוך מיטוב יעילות הנסיעה וצמצום בלבול.',
          },
          sameDriverForGroup: {
            title: 'אותו נהג לקבוצה',
            toolTipInformation:
              'משייך את אותו הנהג להסעת קבוצת הנוסעים הן לאיסוף והן להורדה, ומספק היכרות ועקביות לנוסעים.',
          },
          allowSharedRide: {
            title: 'אפשר נסיעה משותפת עם כתובות אחרות',
            toolTipInformation:
              'כאשר מופעל, הגדרה זו מאפשרת לקבץ נסיעות משותפות עם הזמנות ממיקומים אחרים בעלי מסלולים עקביים. אם מושבת, רק נסיעות מאותו מיקום יישקלו לקיבוץ.',
          },
          tripBoardingTime: {
            title: 'זמן עלייה',
            toolTipInformation:
              'הזמן שנדרש לאסוף נוסע בתחנה שלו (פרמטר זה ישפיע על משך הנסיעה הכולל)',
          },
          waitForBoardingTime: {
            title: 'זמן המתנה לעלייה',
            toolTipInformation: 'בעת הגעה לתחנה, הנהג ימתין עד לזמן האיסוף המדויק, אם צריך.',
          },
          tripDropOffTime: {
            title: 'זמן ירידה',
            toolTipInformation:
              'הזמן שנדרש להוריד נוסע בתחנה שלו (פרמטר זה ישפיע על משך הנסיעה הכולל)',
          },
          rules: {
            header: 'כללי מיקום / פרופילים',
            rule: 'כלל',
            profiles: 'פרופילים',
            addNewRule: '+ הוסף כלל מיקום / פרופיל',
          },
          maxDropOffEarly: {
            title: 'מקסימום הגעה מוקדמת בירידה',
            toolTipInformation:
              'מספר הדקות המקסימלי שנהג יכול להגיע מוקדם ביחס לשעת הירידה שנקבעה בהזמנה',
          },
          maxDropOffDelay: {
            title: 'מקסימום איחור בירידה',
            toolTipInformation:
              'מספר הדקות המקסימלי שנהג יכול לאחר ביחס לשעת הירידה שנקבעה בהזמנה',
          },
          maxBoardingDelay: {
            title: 'מקסימום איחור באיסוף',
            toolTipInformation:
              'מספר הדקות המקסימלי שנהג יכול לאחר ביחס לשעת האיסוף שנקבעה בהזמנה',
          },
          maxBoardingEarly: {
            title: 'מקסימום הגעה מוקדמת באיסוף',
            toolTipInformation:
              'מספר הדקות המקסימלי שנהג יכול להגיע מוקדם ביחס לשעת האיסוף שנקבעה בהזמנה',
          },
          maxTripDuration: {
            title: 'משך נסיעה מרבי',
            toolTipInformation: 'משך מרבי של נסיעה בדקות',
          },
          maxSinglePassengerTime: {
            title: 'משך נסיעה מרבי לנוסע בודד',
            toolTipInformation: 'משך מרבי של נסיעה בדקות לכל נוסע',
          },
        },
      },
      excludedDrivers: {
        header: 'נהגים מוחרגים',
        fields: {
          driversList: 'רשימת נהגים',
          excludedList: 'רשימת מוחרגים',
        },
      },
      excludedVehicles: {
        header: 'רכבים מוחרגים',
        fields: {
          vehiclesList: 'רשימת רכבים',
          excludedList: 'רשימת מוחרגים',
        },
      },
      excludeHolidays: {
        header: 'חגים מוחרגים',
        fields: {
          holidaysList: 'רשימת חגים',
          excludedList: 'חגים מוחרגים',
        },
      },
    },
  },
};

export default locationFacilityTypes;
